import { useState } from "react";
import { Card, Table, Dropdown, Menu, Button, Select, Space, Typography } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { Tag } from "antd";

const getStatusTag = (status) => {
  const normalized = status?.toUpperCase();
  switch (normalized) {
    case "APPROVED":
      return <Tag color="green">Approved</Tag>;
    case "REJECTED":
      return <Tag color="red">Rejected</Tag>;
    case "PENDING":
      return <Tag color="gold">Pending</Tag>;
    default:
      return <Tag>{status}</Tag>;
  }
};

const { Title } = Typography;

const approvalRequests = [
  {
    id: 1,
    title: "Request to update crew member details",
    status: "PENDING",
    date: "2025-04-10",
    createdBy: "Ravi Sharma"
  },
  {
    id: 2,
    title: "New ambulance addition request for District 5",
    status: "APPROVED",
    date: "2025-04-09",
    createdBy: "Anita Verma"
  },
  {
    id: 3,
    title: "Approval needed for zone reallocation of staff",
    status: "REJECTED",
    date: "2025-04-07",
    createdBy: "Siddharth Yadav"
  },
  {
    id: 4,
    title: "Tehsil-level facility access update",
    status: "PENDING",
    date: "2025-04-08",
    createdBy: "Meena Kumari"
  },
  {
    id: 5,
    title: "Supervisor role change for Ajay Singh",
    status: "APPROVED",
    date: "2025-04-06",
    createdBy: "Deepak Chauhan"
  }
];


const statusOptions = ["All", "Approved", "Rejected", "Pending"];

function AuditApproval() {
  const [statusFilter, setStatusFilter] = useState("All");
  const [requests, setRequests] = useState(approvalRequests);

  const handleAction = (id, newStatus) => {
    const updated = requests.map(req => req.id === id ? { ...req, status: newStatus } : req);
    setRequests(updated);
  };

  const filteredRequests = statusFilter === "All"
    ? requests
    : requests.filter(req => req.status === statusFilter);

  const columns = [
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Status", dataIndex: "status", key: "status", render: (status) => getStatusTag(status), },
    { title: "Created By", dataIndex: "createdBy"},
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const menu = (
          <Menu>
            <Menu.Item key="approve" onClick={() => handleAction(record.id, "Approved")}>
              Approve
            </Menu.Item>
            <Menu.Item key="reject" onClick={() => handleAction(record.id, "Rejected")}>
              Reject
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menu} trigger={['click']}>
            <Button icon={<MoreOutlined />} />
          </Dropdown>
        );
      }
    }
  ];

  return (
    <Card style={{ margin: "2rem" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <Title level={3} style={{ margin: 0 }}>Manage your Approval Requests here</Title>
        <Select
          style={{ width: 200 }}
          value={statusFilter}
          onChange={setStatusFilter}
          options={statusOptions.map(status => ({ value: status, label: status }))}
        />
      </div>

      <Table
        dataSource={filteredRequests.map(item => ({ ...item, key: item.id }))}
        columns={columns}
        pagination={{ pageSize: 5 }}
      />
    </Card>
  );
}

export default AuditApproval;
